export const COLORS = {
	disabledColor: '#9E9E9E',
	disabledBg: '#E0E0E0',
	default: {
		color: '#3F3F3F',
		background: '#E0E0E0',
		focusBg: '#AEAEAE',
		focusBgLight: 'rgba(224, 224, 224, 0.1)',
		boxShadow: '0px 2px 3px rgba(51, 51, 51, 0.2)'
	},
	primary: {
		color: '#FFFF',
		background: '#2962FF',
		focusBg: '#0039CB',
		focusBgLight: 'rgba(41, 98, 255, 0.1)',
		boxShadow: '0px 2px 3px rgba(41, 98, 255, 0.2)'
	},
	secondary: {
		color: '#FFFF',
		background: '#455A64',
		focusBg: '#1C313A',
		focusBgLight: 'rgba(69, 90, 100, 0.1)',
		boxShadow: '0px 2px 3px rgba(69, 90, 100, 0.2)'
	},
	danger: {
		color: '#FFFF',
		background: '#D32F2F',
		focusBg: '#9A0007',
		focusBgLight: 'rgba(211, 47, 47, 0.1)',
		boxShadow: '0px 2px 3px rgba(211, 47, 47, 0.2)'
	}
}

export const SIZE = {
	sm: `${4 / 16}rem ${10 / 16}rem`,
	md: `${9 / 16}rem ${16 / 16}rem`,
	default: `${9 / 16}rem ${16 / 16}rem`,
	lg: `${14 / 16}rem ${22 / 16}rem`
}
